import { useState } from 'react';

export default function Hero() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center pt-20 pb-16 bg-cover bg-center"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/0ff2d0ed776a73f6d2ec0d5fafb6ae0e.jpg')`
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-indigo-900/95 via-purple-900/90 to-indigo-900/95"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="text-white">
            <div className="inline-flex items-center space-x-2 bg-white/10 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
              <i className="ri-sparkling-line text-yellow-400"></i>
              <span className="text-sm font-medium">AI-Powered E-Commerce Revolution</span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold mb-6 leading-tight">
              Transform Your Retail Experience with <span className="bg-gradient-to-r from-yellow-400 to-pink-400 bg-clip-text text-transparent">Intelligent Commerce</span>
            </h1>
            
            <p className="text-xl text-gray-200 mb-8 leading-relaxed">
              Discover the future of online shopping with our AI-driven marketplace. Intelligent product discovery, automated analytics, and seamless fulfillment management—all in one powerful platform designed for modern consumers and suppliers.
            </p>

            <div className="bg-white rounded-2xl p-2 shadow-2xl mb-8 max-w-2xl">
              <div className="flex items-center space-x-2">
                <div className="flex-1 flex items-center space-x-3 px-4">
                  <i className="ri-search-line text-gray-400 text-xl"></i>
                  <input
                    type="text"
                    placeholder="Search for products using AI... (e.g., 'wireless headphones for running')"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    className="flex-1 py-3 text-gray-800 outline-none text-base"
                  />
                </div>
                <button className="px-8 py-3 bg-gradient-to-r from-indigo-600 to-purple-600 text-white rounded-xl hover:shadow-lg transition-all font-medium cursor-pointer whitespace-nowrap">
                  Search
                </button>
              </div>
            </div>

            <div className="flex flex-wrap gap-4">
              <button className="px-8 py-4 bg-white text-indigo-600 rounded-xl hover:shadow-2xl transition-all font-semibold cursor-pointer whitespace-nowrap flex items-center space-x-2">
                <span>Start Selling</span>
                <i className="ri-arrow-right-line"></i>
              </button>
              <button className="px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-xl hover:bg-white/20 transition-all font-semibold cursor-pointer whitespace-nowrap flex items-center space-x-2">
                <i className="ri-play-circle-line text-xl"></i>
                <span>Watch Demo</span>
              </button>
            </div>

            <div className="flex items-center space-x-8 mt-12">
              <div>
                <div className="text-3xl font-bold">50K+</div>
                <div className="text-gray-300 text-sm">Active Sellers</div>
              </div>
              <div className="w-px h-12 bg-white/20"></div>
              <div>
                <div className="text-3xl font-bold">2M+</div>
                <div className="text-gray-300 text-sm">Products Listed</div>
              </div>
              <div className="w-px h-12 bg-white/20"></div>
              <div>
                <div className="text-3xl font-bold">98%</div>
                <div className="text-gray-300 text-sm">Satisfaction Rate</div>
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl blur-2xl opacity-30"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Advanced%20AI%20technology%20dashboard%20showing%20real-time%20e-commerce%20analytics%20with%20colorful%20data%20visualizations%2C%20product%20recommendation%20algorithms%2C%20neural%20network%20graphs%2C%20and%20intelligent%20shopping%20interface%20on%20modern%20tablet%20device%2C%20floating%20holographic%20elements%2C%20clean%20professional%20design%2C%20futuristic%20user%20interface%2C%20vibrant%20colors%20with%20blue%20and%20purple%20accents%2C%20high-tech%20atmosphere&width=600&height=700&seq=hero-img-001&orientation=portrait"
                alt="AI E-Commerce Platform"
                className="relative rounded-3xl shadow-2xl w-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
